import { render, staticRenderFns } from "./SalePageList.vue?vue&type=template&id=0b5bbfac&"
import script from "./SalePageList.vue?vue&type=script&lang=js&"
export * from "./SalePageList.vue?vue&type=script&lang=js&"
import style0 from "./SalePageList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports